import api from '~/config/api';

export const registerErrorSystem = async (data: object) => {
  try {
    await api.post('/api/system/register', data);
  } catch (error) {}
};
